import React from "react"
import {sortBy,filter} from 'lodash'
import {navigate} from 'gatsby'
import Swal from 'sweetalert2'
import axios from "axios"
import moment from "moment";
import "moment/locale/sv";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.min.css";
import '../components/datepicker.scss'

import Layout from "../components/layout"
import SEO from "../components/seo"
import Dish from "../components/dish";
import CateringModal from '../components/cateringModalDish';
import CateringDishesSummary from '../components/cateringDishesSummary'
import CateringContactForm from '../components/cateringContactForm'


const steps = ['main course', 'contact form', 'confirmation'];
const defaultFormData = {
  name:'',
  mobile:'',
  delivery: null,
  restaurant:null,
  address:'',
  date:null,
  time:null,
  extraInfo:'',
};

export default class Catering extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
    Object.assign(this.state,{
      step: 'main course', // 'main course' / 'contact form' / 'confirmation'
      variantsModalOpen:false,
      modalDish:null,
      amounts:{},
      datePickerOpen:false,
    }, defaultFormData);
    moment.locale('sv');
    this.onClickOut = this.onClickOut.bind(this);
    this.openVariantsModal = this.openVariantsModal.bind(this);
    this.setAmount = this.setAmount.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSenderClick = this.handleSenderClick.bind(this);
  }

  componentWillMount() {
    this.setState({...defaultFormData});
  }

  onClickOut() {
    this.setState({variantsModalOpen:false});
  }

  openVariantsModal(modalDish) {
    this.setState({modalDish, variantsModalOpen:true});
  }

  setAmount(dishName, variantName, amount) {
    let amounts = this.state.amounts;
    if (!(dishName in amounts)) amounts[dishName] = {};
    amounts[dishName][variantName] = amount;
    this.setState({amounts});
  }

  prevStep() {
    if (this.state.step === steps[0]) {
      return navigate('/');
    } else {
      let prevStepIndex = (steps.indexOf(this.state.step) === 0) ? steps.length : steps.indexOf(this.state.step) - 1;
      this.setState({step:steps[prevStepIndex]});
    }
  }

  handleInputChange(ev) {
    const value = ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value;
    this.setState({
      [ev.target.name]: value,
    });
  }

  getTotalAmount() {
    let totalAmount = 0;
    Object.keys(this.state.amounts).map(dishName =>
      Object.keys(this.state.amounts[dishName]).map(variantName =>
        totalAmount += this.state.amounts[dishName][variantName]
      )
    );
    return totalAmount;
  }

  checkAmounts() {
    return this.getTotalAmount() >= 10;
  }

  nextStep() {
    if (!this.checkAmounts()) {
      window && window.alert('Minsta antal portioner: 10. Du behöver välja minst '+(10-this.getTotalAmount())+' till.');
    } else {
      let nextStepIndex = (steps.indexOf(this.state.step) === steps.length) ? 0 : steps.indexOf(this.state.step) + 1;
      this.setState({step:steps[nextStepIndex]});
    }
  }

  getData() {
    let mainCourse = [];

    Object.keys(this.state.amounts).map(dishName => {
      let meal = dishName+': ';
      Object.keys(this.state.amounts[dishName]).map(variantName => {
        meal+= this.state.amounts[dishName][variantName]+'st '+variantName+', ';
      });
      mainCourse.push(meal);
    });

    return {
      namn: this.state.name,
      mobilnummer: this.state.mobile,
      leverans: (this.state.delivery === 'upphämtning')
        ? 'Upphämtning på restaurang:' + this.state.restaurant
        : 'Leverans till: ' + this.state.address,
      datum: moment(this.state.date).format('YYYY-MM-DD'),
      tid: this.state.time,
      info: this.state.extraInfo,
      'huvudrätter': mainCourse.join("\n"),
      'pris': (this.getTotalAmount()*140)+'kr '+(this.state.delivery !== 'upphämtning' ? ' + leveransavgift (300kr - 500kr)' : '')
    }
  }

  validateForm() {
    if (this.state.name.length < 3 || this.state.mobile.length < 3) return 'Fyll in ditt namn och mobilnummer';
    if (!this.state.delivery) return 'Välj upphämtning eller leverans';
    if (this.state.delivery === 'upphämtning' && !this.state.restaurant) return 'Välj restaurant där du vill hämta din beställning';
    if (this.state.delivery === 'leverans' && !this.state.address) return 'Ange leveransadress';
    if (!this.state.date || !this.state.time) return 'Ange datum och tid';

    return true;
  }

  handleSenderClick() {
    const formValidationResult = this.validateForm();
    if ( formValidationResult !== true ) {
      return Swal.fire('Nånting gick fel', formValidationResult, 'error');
    }
    this.setState({step:'loading'});
    axios
      .post(
        'https://datasets.recondex.se/thwcatering',
        this.getData(),
        {'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8',}
      )
      .then(response => {
        const ok = response.data === 'ok';
        if (ok) {
          this.setState({step:'confirmation',amounts:{}, ...defaultFormData});
        } else {
          window && window.alert('Ett fel har inträffat. Vänligen försök igen senare');
        }
      })
      .catch(error => {
        window && window.alert('Ett fel har inträffat. Vänligen försök igen senare');
      });
  }

  render() {
    const dishes = sortBy(filter(this.props.data.allContentfulMatratt.edges, dish => parseInt(dish.node.number) <= 24 && dish.node.type !== 'premium'), dish => dish.node.number);
    const amounts = (this.state.modalDish && this.state.modalDish.props.title in this.state.amounts)
      ? this.state.amounts[this.state.modalDish.props.title]
      : {};

    return (
      <Layout>
        <SEO title="Catering" keywords={[`thai house wok`, `catering`]}/>
        <CateringModal
          open={this.state.variantsModalOpen}
          onClickOut={() => this.setState({variantsModalOpen:false})}
          onCancel={() => this.setState({variantsModalOpen:false})}
          dish={this.state.modalDish}
          amounts={amounts}
          onAmountSet={this.setAmount}
           />
        {this.state.datePickerOpen && (
          <DatePicker
            selected={this.state.date}
            onChange={(date) => this.setState({date,datePickerOpen:false})}
            withPortal
            minDate={new Date()}
            onClickOutside={() => this.setState({datePickerOpen: false})}
            locale="sv"
            inline />
        )}
        <div className="page">
          <div className="page-header">
            <h1>Beställ catering</h1>
          </div>
          <div className="bg-purple">
            <ul className="nav nav-tabs nav-fill justify-content-center mx-auto nav-progress tight pl-4 pr-4 mb-0">
              <li className="nav-item">
                <button onClick={() => this.setState({step:'main course'})} className={'nav-link ' + (this.state.step==='main course'?'active':'')}>
                  Huvudrätter
                </button>
              </li>
              <li className="nav-item"><span className="nav-link">&raquo;</span></li>
              <li className="nav-item">
                <button onClick={() => this.setState({step:'contact form'})} className={'nav-link ' + (this.state.step==='contact form'?'active':'')}>
                  Kontaktinfo
                </button>
              </li>
              <li className="nav-item"><span className="nav-link">&raquo;</span></li>
              <li className="nav-item">
                <button className={'nav-link ' + (this.state.step==='confirmation'?'active':'')}>
                  Bekräftelse
                </button>
              </li>
            </ul>
          </div>
          {this.state.step === 'loading' && (
            <div className="container text-outer tight">
              <h3>Vänta...</h3>
            </div>
          )}
          {this.state.step === 'main course' && (
            <div className="dishes tight">
              {dishes.map(dish =>
                <div className="col-12" key={'col-'+dish.node.id}>
                  <Dish selectable catering
                        onChoseClick={this.openVariantsModal}
                        number={dish.node.number}
                        title={dish.node.title}
                        imgData={dish.node.image ? dish.node.image.fluid : null}
                        prices={dish.node.prices || dish.node.category.defaultPrices}
                        spiciness={dish.node.spiciness}
                        description={dish.node.description}
                  />
                </div>
              )}
            </div>
          )}
          {this.state.step === 'contact form' && (
            <CateringContactForm
              name={this.state.name}
              mobile={this.state.mobile}
              delivery={this.state.delivery}
              restaurant={this.state.restaurant}
              address={this.state.address}
              date={this.state.date}
              time={this.state.time}
              extraInfo={this.state.extraInfo}
              handleInputChange={this.handleInputChange}
              handleSenderClick={this.handleSenderClick}
              openDatePicker={() => this.setState({datePickerOpen:true})}
            />
          )}
          {this.state.step === 'confirmation' && (
            <div className="container text-outer tight text-center">
              <h2>Tack</h2>
              <p>
                Din beställning är skickad!<br />
                Vi kommer att kontakta dig inom kort.
              </p>
            </div>
          )}
        </div>
        {(this.state.step === 'main course') && (
          <CateringDishesSummary
            amounts={this.state.amounts}
            step={this.state.step}
            onPrev={() => this.prevStep()}
            onNext={() => this.nextStep()}
            isFirstStep={this.state.step === steps[0]}
            isLastStep={this.state.step === steps.indexOf(steps.length-1)}
          />
        )}
      </Layout>
    );
  }
}

export const pageQuery = graphql`
query{
  allContentfulMatratt(
    limit: 1000
    sort: {
      fields: [number]
      order: ASC
    }
  ) {
    edges {
      node {
        id
        number
        title
        type
        description
        spiciness
        image{
          file { url }
          fluid(maxWidth: 1600) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        prices
        category{
          id
          defaultPrices
        }
      }
    }
  }
}
`
